import type { SVGProps } from 'react'
const SvgFacebookLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    fill="none"
    viewBox="0 0 28 28"
    {...props}
  >
    <path
      fill="currentColor"
      d="m18.43 15.72.58-3.77h-3.62V9.5c0-1.03.5-2.03 2.13-2.03h1.64V4.25S17.66 4 16.24 4c-2.98 0-4.93 1.8-4.93 5.08v2.87H8v3.77h3.31v9.12c1.35.21 2.73.21 4.08 0v-9.12z"
    />
  </svg>
)
export default SvgFacebookLogo
